<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Merchant</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button v-show="canImportExportFile"
          @click="handleDownloadFile('LIST')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download" /> Xuất file
        </button>
        <button v-show="canImportExportFile"
          @click="handleDownloadFile('EXAMPLE')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download" /> Tải file mẫu
        </button>
        <button v-show="canImportExportFile"
          @click="triggerImportFile"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle" /> Import file
        </button>
        <button
          @click="$router.push({name: 'MerchantCreate'})"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
      </div>
      <input
        type="file"
        ref="inputImportRef"
        @change="handleChangeFile"
        accept=".xlsx, .xls"
        style="display: none"
      />
    </div>
    <div class="p-10  pt-15 b-t-1-869fb229">
      <FilterMerchantForm ref="filterMerchantFormRef" @change="handleFilter" />
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="list"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(merchantName)="{item}">
                <router-link :to="'/merchant/detail/' + item.leadId">{{ item.merchantName }}</router-link>
              </template>
              <template #cell(customerName)="{item}">
                <p>{{ item.customerName }}</p>
                <p>{{ item.mobile }}</p>
                <p>{{ item.email }}</p>
              </template>
              <template #cell(merchantAgentStatus)="{item}">
                <Status :value="item.merchantAgentStatus" :config="Config.merchantStatus"/>
              </template>
              <template #cell(shippingStatus)="{item}">
                <b-badge v-show="item.shippingStatus" :variant="mapVariantShippingStatus[item.shippingStatus]">
                  {{ mapTextShippingStatus[item.shippingStatus] }}
                </b-badge>
              </template>
              <template #cell(deliveryTime)="{item}">
                {{ item.deliveryTime | formatDate("DD/MM/YYYY")}}
              </template>
              <template #cell(handoverType)="{item}">
                <b-badge v-show="item.handoverType" :variant="mapVariantHandoverType[item.handoverType]">
                  {{ mapTextHandoverType[item.handoverType] }}
                </b-badge>
              </template>
              <template #cell(fee)="{item}">
                {{ item.fee | fomatCurrency }}
              </template>
              <template #cell(createAt)="{item}">
                {{item.createAt | formatDateTime7}}
              </template>
              <template #cell(action)="{item}">
                     <button
                    class="btn btn-info btn-sm mr-2"
                    @click="$router.push('/merchant/detail/' + item.leadId)"
                >
                  Chi tiết
                </button>
                <button
                    v-if="item.status === 'NEW'"
                     class="btn btn-success btn-sm"
                    @click="$router.push('/merchant/update/' + item.leadId)"
                  >
                  Cập nhật
                </button>

              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom mr-5">
        <b-form-group class="mb-0" style="padding: 17px">
          <b-form-select
            v-model="search.limit"
            :options="pageOptions"
            @change="onItemsPerPageChange"
          ></b-form-select>
        </b-form-group>
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="mr-2 fl-right mr-4"
          @change="onChangePage"
        ></b-pagination>
      </div>
    </div>
    <PopupImportResultComponent ref="popupImportResultRef" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>
<script>
import { MerchantService } from '@/services/merchant.service'
import { showMessSuccess, showMessErrorResponse, showMessError } from '@/config/utils'
import fileDownload from 'js-file-download'
import PopupImportResultComponent from './components/PopupImportResultComponent.vue'
import FilterMerchantForm from './components/FilterMerchantForm.vue'
import Config from '@/thirdParty/config'
import cloneDeep from 'lodash/cloneDeep'

const fieldsTable = [
  { key: 'index', label: 'STT', class: 'text-center' },
  { key: 'merchantName', label: 'Tên Merchant' },
  { key: 'customerName', label: 'Người Đại diện' },
  { key: 'address', label: 'Địa chỉ' },
  { key: 'mccName', label: 'Ngành nghề' },
  { key: 'merchantAgentStatus', label: 'Trạng thái' },
  { key: 'shippingStatus', label: 'Trạng thái giao hàng', class: 'text-center' },
  { key: 'deliveryTime', label: 'Thời gian giao hàng' },
  { key: 'handoverType', label: 'Hình thức vận chuyển', class: 'text-center' },
  { key: 'fee', label: 'Giá tiền', class: 'text-right' },
  { key: 'deliveryFailureReason', label: 'Lý do', thStyle: { minWidth: '150px' } },
  { key: 'createAt', label: 'Thời gian tạo' },
  { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' }
]
const pageOptions = [
  { value: 50, text: '50/trang' },
  { value: 100, text: '100/trang' },
  { value: 200, text: '200/trang' }
]
const searchFieldDefault = Object.freeze({
  page: 1,
  limit: 50
})

export default {
  name: 'Merchant',
  components: {
    PopupImportResultComponent,
    FilterMerchantForm
  },
  data () {
    return {
      loading: false,
      showLoading: false,
      fieldsTable,
      filterTable: fieldsTable,
      list: [],
      search: cloneDeep(searchFieldDefault),
      pagination: {
        total: 0
      },
      provinceList: [],
      pageOptions
    }
  },
  async mounted () {
    this.fetchData()
    this.provinceList = await this.getProvinceMx()
  },
  computed: {
    canImportExportFile () {
      return this.dataUser.partnerCode === 'VCBHO' &&
      this.dataUser.permissionCodes.includes('CNPS_LEAD_VCBHO_IMPORT_FILE')
    },
    mapTextShippingStatus () {
      return Config.optionsShippingStatus.reduce((acc, item) => {
        acc[item.id] = item.text
        return acc
      }, {})
    },
    mapVariantShippingStatus () {
      return Config.optionsShippingStatus.reduce((acc, item) => {
        acc[item.id] = item.variant
        return acc
      }, {})
    },
    mapTextHandoverType () {
      return Config.optionsHandoverType.reduce((acc, item) => {
        acc[item.id] = item.text
        return acc
      }, {})
    },
    mapVariantHandoverType () {
      return Config.optionsHandoverType.reduce((acc, item) => {
        acc[item.id] = item.variant
        return acc
      }, {})
    }
  },
  methods: {
    async handleFilter (payload) {
      this.search = { ...searchFieldDefault, ...payload }
      await this.fetchData()
    },
    async onChangePage (page) {
      this.search.page = page
      await this.fetchData()
    },
    async onItemsPerPageChange () {
      this.search.page = 1
      await this.fetchData()
    },
    async submitForm (event) {
      event.preventDefault()
      this.fetchData()
    },
    async removeForm () {
      this.search = {
        limit: 50,
        page: 1
      }
      await this.fetchData()
    },

    // Dữ liệu bảng
    async fetchData () {
      try {
        this.loading = true
        const params = { ...this.search }
        params.agentId = this.dataUser.agentId
        const data = await MerchantService.fetch(params)
        if (data.success) {
          this.list = data.data
          this.pagination.total = data.meta.pagination.total ?? 0
        } else {
          this.list = []
          this.pagination.total = 0
        }
      } catch (error) {
        this.list = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },
    async handleDownloadFile (type) {
      const params = { ...searchFieldDefault, ...this.$refs.filterMerchantFormRef.params() }

      const mapType = {
        LIST: {
          api: (params) => MerchantService.exportListLeads(params),
          name: 'Danh_sach_leads.xlsx'
        },
        EXAMPLE: {
          api: () => MerchantService.downloadExampleFileMcAgent(),
          name: 'template_import_lead_for_vcb_ho.xlsx'
        }
      }
      const action = mapType[type]
      if (!action) return
      const func = action.api
      try {
        this.showLoading = true
        const res = await func.bind(MerchantService)(params)
        fileDownload(res.data, action.name)
        showMessSuccess(this, `Download ${action.name} thành công`)
      } catch (error) {
        showMessErrorResponse(this, error.response?.data?.message || error.response?.message || error.message)
      } finally {
        this.showLoading = false
      }
    },
    triggerImportFile () {
      this.$refs.inputImportRef.value = ''
      this.$refs.inputImportRef.click()
    },
    async handleChangeFile (event) {
      const file = event.target.files[0]
      if (!file) return
      const fileType = file.name.split('.').pop().toLowerCase()
      if (!['xlsx', 'xls'].includes(fileType)) {
        showMessError(this, 'Vui lòng chọn file Excel (.xlsx, .xls)')
        this.$refs.inputImportRef.value = ''
        return
      }
      try {
        this.showLoading = true
        const res = await MerchantService.importFileListMc(file, {
          agentId: this.dataUser.agentId
        })
        if (res.code === 1000) {
          this.$refs.popupImportResultRef.openModal(res.data)
        } else {
          showMessError(this, res.message)
        }
      } catch (error) {
        showMessErrorResponse(this, error)
      } finally {
        this.showLoading = false
      }
    }
  }
}
</script>
<style scoped>
.breadcrumb-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.box-search {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.form-group {
  margin-bottom: 10px;
  min-width: 200px;
}

.form-group-action {
  display: flex;
  align-items: flex-end;
}

.pagination-bottom {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
</style>
